import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider, useAuth } from "@/lib/auth";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";
import LoginPage from "@/pages/LoginPage";
import VerifyPage from "@/pages/VerifyPage";
import PhotographerDashboard from "@/pages/PhotographerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ArchivePage from "@/pages/ArchivePage";
import ApplicantsAdmin from "@/pages/ApplicantsAdmin";
import ApplyPage from "@/pages/ApplyPage";
import RosterHeatmapPage from "@/pages/RosterHeatmapPage";
import TemplatesAdmin from "@/pages/TemplatesAdmin";
import FinalExam from "@/pages/FinalExam";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <LoginPage />;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster
            theme="light"
            position="top-right"
            toastOptions={{
              style: {
                background: "#FBF4E4",
                border: "1px solid rgba(26,15,10,0.12)",
                color: "#1A0F0A",
                borderRadius: "4px",
                fontFamily: "'Noir Pro', sans-serif",
              },
            }}
          />
          <Routes>
            <Route path="/" element={<RootRedirect />} />
            <Route path="/auth/verify" element={<VerifyPage />} />
            {/* Public applicant intake — no auth wrapper. Anyone with the
                URL can submit; honeypot handles bot noise. */}
            <Route path="/apply" element={<ApplyPage />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <PhotographerDashboard />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute requireAdmin>
                  <AppShell>
                    <AdminDashboard />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/templates"
              element={
                <ProtectedRoute requireAdmin>
                  <AppShell>
                    <TemplatesAdmin />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/applicants"
              element={
                <ProtectedRoute requireAdmin>
                  <AppShell>
                    <ApplicantsAdmin />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/archive"
              element={
                <ProtectedRoute requireAdmin>
                  <AppShell>
                    <ArchivePage />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/roster-map"
              element={
                <ProtectedRoute requireAdmin>
                  <AppShell>
                    <RosterHeatmapPage />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route
              path="/final-exam"
              element={
                <ProtectedRoute>
                  <AppShell>
                    <FinalExam />
                  </AppShell>
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
